/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as pxp from './PXPApp'
import { componentApi, loadTranslations } from 'common'


export class SvueHallPass {
  async GetStudentHallPassData() : Promise<pxp.SvueStuHallPassDataVM> {
    return await componentApi.call('pxp', 'svue-hallpass', 'SvueHallPass', 'GetStudentHallPassData', {
    });
  }
  async GetHallPassRooms() : Promise<Array<pxp.ComponentRoomData>> {
    return await componentApi.call('pxp', 'svue-hallpass', 'SvueHallPass', 'GetHallPassRooms', {
    });
  }
  async GetFuturePasses() : Promise<Array<pxp.ComponentHallPassData>> {
    return await componentApi.call('pxp', 'svue-hallpass', 'SvueHallPass', 'GetFuturePasses', {
    });
  }
  async CreateHallPass(roomGU : string, minutes : number) : Promise<pxp.CreateHallPassResponse> {
    return await componentApi.call('pxp', 'svue-hallpass', 'SvueHallPass', 'CreateHallPass', {
      roomGU,
      minutes,
    });
  }
  async DeleteHallPass(hallPassGU : string) : Promise<pxp.HallPassResponseBase> {
    return await componentApi.call('pxp', 'svue-hallpass', 'SvueHallPass', 'DeleteHallPass', {
      hallPassGU,
    });
  }
  async CheckActivateQueuedHallPass(hallPassGU : string) : Promise<pxp.CheckActivateQueuedHallPassResponse> {
    return await componentApi.call('pxp', 'svue-hallpass', 'SvueHallPass', 'CheckActivateQueuedHallPass', {
      hallPassGU,
    });
  }
  async RemoveFutureHallPass(hallPassGU : string) : Promise<pxp.HallPassResponseBase> {
    return await componentApi.call('pxp', 'svue-hallpass', 'SvueHallPass', 'RemoveFutureHallPass', {
      hallPassGU,
    });
  }
}
export default new SvueHallPass()
